import React from "react";

const normalize = (value) => (Array.isArray(value) ? value.map(String) : []);

export default function QuestionQcm({ question, value, onChange, disabled }) {
    const selectedValues = normalize(value);

    const toggle = (optionId) => {
        const optionKey = String(optionId);
        const next = selectedValues.includes(optionKey)
            ? selectedValues.filter((item) => item !== optionKey)
            : [...selectedValues, optionKey];
        onChange(next);
    };

    return (
        <div className="qr-options-list">
            {(question.reponsesPossibles || []).map((option) => {
                const checked = selectedValues.includes(String(option.id));
                return (
                    <label key={option.id} className={`qr-option-card ${checked ? "is-selected" : ""}`}>
                        <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => toggle(option.id)}
                            disabled={disabled}
                        />
                        <span>{option.libelle}</span>
                    </label>
                );
            })}
        </div>
    );
}
